import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSEO } from "../lib/seo";
import { BRAND } from "../data/site";

const VALUES = [
    { t: "Quality", b: "Lab-tested for moisture, ASTA, SHU, curcumin and microbial load on every consignment." },
    { t: "Transparency", b: "Clear pricing, traceable sourcing, and full export documentation with every shipment." },
    { t: "Timely Delivery", b: "FOB, CIF and CFR ex Chennai, Krishnapatnam and Mundra — shipped on schedule." },
    { t: "Long-term Partnerships", b: "We're built for repeat buyers — same farms, same grades, same standards, season after season." },
];

export default function About() {
    useSEO({
        title: "About RP Traders — Trusted Indian Spices & Agro Commodities Exporter",
        description:
            "RP Traders is a Guntur-based exporter of premium Indian spices and agro commodities, sourcing direct from farms and supplying buyers across 30+ countries since 2016.",
        keywords:
            "About RP Traders, Indian spices exporter Guntur, agro commodities exporter India",
    });
    return (
        <main className="bg-white pt-32 pb-24 sm:pt-40">
            <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
                <span className="text-xs uppercase tracking-[0.22em] text-brand-red">About Us</span>
                <h1 className="mt-3 max-w-4xl font-display text-4xl font-bold leading-[1.04] tracking-[-0.03em] sm:text-6xl">
                    A trusted Indian spices &amp; agro commodities exporter, based in Guntur.
                </h1>
                <p className="mt-6 max-w-3xl text-base leading-relaxed text-ink-muted sm:text-lg">
                    RP Traders is a trusted Indian spices and agro commodities exporter based in
                    Guntur, Andhra Pradesh. We work closely with farmers and reliable sourcing
                    networks to supply premium quality spices to international buyers. Our focus is
                    quality, transparency, timely delivery, and long-term business relationships.
                </p>

                <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    {VALUES.map((v) => (
                        <div key={v.t} className="rounded-3xl border border-hairline bg-neutral-bg p-6">
                            <h3 className="font-display text-lg font-bold tracking-tight">{v.t}</h3>
                            <p className="mt-2 text-sm leading-relaxed text-ink-muted">{v.b}</p>
                        </div>
                    ))}
                </div>

                <div className="mt-16 rounded-3xl border border-hairline bg-neutral-bg p-8 sm:p-12">
                    <div className="grid gap-8 lg:grid-cols-2">
                        <div>
                            <span className="text-xs uppercase tracking-[0.22em] text-brand-red">Head Office</span>
                            <p className="mt-3 text-ink">{BRAND.head}</p>
                        </div>
                        <div>
                            <span className="text-xs uppercase tracking-[0.22em] text-brand-red">Branch Office</span>
                            <p className="mt-3 text-ink">{BRAND.branch}</p>
                        </div>
                    </div>
                    <Link
                        to="/contact"
                        data-testid="about-cta-contact"
                        className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-red px-6 py-3 text-sm font-semibold text-white hover:scale-[1.03] transition-transform"
                    >
                        Contact our export desk <ArrowRight className="h-4 w-4" />
                    </Link>
                </div>
            </div>
        </main>
    );
}
